// node_modules
import {
    useCallback
} from "react";
// Types
import { TEnvironmentVariableDTO, TSavedQueryTempDTO } from "Types";
// Controllers
import { EnvironmentControllerSingleton } from "Controllers";

export const useKeywords = (
        selectedCaseId: number | undefined, 
        selectedOriginalTechnologyId: number | undefined, 
        selectedSavedQuery: TSavedQueryTempDTO | undefined, 
        updateSavedQuery: (newSavedQuery: TSavedQueryTempDTO | undefined) => void, 
        duplicateSavedQuery: (selectedOriginalTechnologyId: number | undefined, selectedCaseId: number | undefined, callback: (duplicatedSavedQuery: TSavedQueryTempDTO) => Promise<void>) => Promise<void>)
            : [(value: string, searchTermGroupId?: string) => Promise<void>, (value: string, savedQuery: TSavedQueryTempDTO | undefined) => TEnvironmentVariableDTO | undefined] => {

    // Logic
    const getDuplicatedKeywordFromValueInSavedQuery = useCallback((value: string, savedQuery: TSavedQueryTempDTO | undefined): TEnvironmentVariableDTO | undefined => {
        if (!value || !savedQuery || (savedQuery && !savedQuery.environmentVariables)) { return undefined; }
        
        for (const keyword of savedQuery.environmentVariables) {
            if (keyword.environment.trim().toLowerCase() === value.trim().toLowerCase()) { 
                return keyword;
            }
        }
        
        return undefined;
    }, []);

    const addKeyword = async (newKeywordValue: string, searchTermGroupId?: string): Promise<void> => {
        // safety-checks
        if (!selectedSavedQuery) { return; }

        // safety-checks
        newKeywordValue = newKeywordValue.trim();
        if (!newKeywordValue) { return; }

        // safety-checks
        if (getDuplicatedKeywordFromValueInSavedQuery(newKeywordValue, selectedSavedQuery)) { return; }

        if (selectedSavedQuery.isUserAdded && selectedSavedQuery.isOwnedByCurrentUser) {
            // init new keyword data
            const newKeyword = await EnvironmentControllerSingleton.createAsync(selectedSavedQuery.guid, true, newKeywordValue, searchTermGroupId);
            // update keywords list of selected saved query
            selectedSavedQuery.environmentVariables = [...selectedSavedQuery.environmentVariables, newKeyword];
            updateSavedQuery(selectedSavedQuery);
        } else {
            duplicateSavedQuery(selectedOriginalTechnologyId, selectedCaseId, async (duplicatedSavedQuery: TSavedQueryTempDTO): Promise<void> => {
                // safety-checks
                if (!duplicatedSavedQuery) { return; }
                // init new keyword data
                const newKeyword = await EnvironmentControllerSingleton.createAsync(duplicatedSavedQuery.guid, true, newKeywordValue, searchTermGroupId);
                // update keywords list of selected saved query
                duplicatedSavedQuery.environmentVariables = [...duplicatedSavedQuery.environmentVariables, newKeyword];
                updateSavedQuery(duplicatedSavedQuery);
            });
        }
    };
    

    return [addKeyword, getDuplicatedKeywordFromValueInSavedQuery];
};
